var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroBlobWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1005,
    viewBox: "0 0 1920 1005",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_212_65",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -493,
    y: -11,
    width: 2413,
    height: 1026
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -493,
    y: -11,
    width: 2413,
    height: 1026,
    rx: 23.8933,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_212_65)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M729.962 928.026C449.034 979.307 374.057 1133.15 379.056 1177.6L1828.69 1234.01L1851.69 196.405C1868.35 91.5625 1875.88 -118.123 1772.71 -118.123C1643.74 -118.123 1483.78 -111.285 1347.81 464.78C1211.85 1040.85 963.99 885.305 729.962 928.026Z",
    fill: "#FECE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.026 971.988C391.066 991.134 354.074 1095.06 359.073 1139.51L1933.31 1195.92L1952.31 45.4974C1968.97 -59.3453 1451.04 -156.211 1347.86 -156.211C1104.49 -156.211 1079.49 16.4378 943.523 592.503C807.552 1168.57 813.977 948.057 579.026 971.988Z",
    fill: "#FECE2F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBlobWeb);
export default __webpack_public_path__ + "static/media/Hero-blob-web.b340473c153a9f0fdfa53cb5ba9c54b3.svg";
export { ForwardRef as ReactComponent };